
import { ValidateDec } from '@/decorators';
import { TSX, Component, Prop, Vue } from 'vue-facing-decorator'

interface Props {
  options: any
}

// 用 TSX<Props>() 声明 props，index.tsx 里 <InstanceBox options={...}> 才通得过类型检查
@Component({
})
export default class extends TSX<Props>()(Vue) implements Props {
  @Prop({
    default() {
      return {};
    }
  })
  options: any;
  ruleForm = {
    appid: "",
    page: "",
  }
  created() {
    this.ruleForm.appid = this.options.appid || "";
    this.ruleForm.page = this.options.page || "";
  }
  @ValidateDec("formTable")
  async submitForm() {
    this.$emit("resolve", this.ruleForm);
  }
}
